import { rpt2Api } from '../api';
import { apiEnv } from '../api/configDomain';

// 判断当前机构是否要走华为云
const checkOrgIsHw = async() => {
  try {
    const res = await rpt2Api.get('config/hw/orgs');
    const orgId = localStorage.getItem('orgId');
    let isHw = false;
    let isXc = false;
    if (res && res.orgs && orgId) {
      // 判断腾讯走信创域名
      if (apiEnv === 'tcprod' && res.orgs.indexOf('all-xc-orgs') !== -1) {
        isXc = true;
        isHw = true;
      } else {
        // 走华为域名
        isHw = res.orgs.split(',').includes(orgId) || (apiEnv === 'tcprod' && res.orgs.indexOf('all-hw-orgs') !== -1);
      }
    }

    localStorage.setItem('hw_report', isHw);
    localStorage.setItem('xc_report', isXc);
  } catch (e) {}
};

export { checkOrgIsHw };
